<template>
  <button type="button" class="agent-service-send-button"
    :class="{ 'has-content': hasContent }" :disabled="disabled || !hasContent"
    :title="$t('agentServiceUI.sendMessage')" :aria-label="$t('agentServiceUI.sendMessage')"
    @click="send">
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
      <path d="m3 10 18-7-7 18-4-7-7-4Z M10 14 21 3"
        stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </button>
</template>

<script>
/** 公共圆形发送入口；空白不可发送，权限和在途状态由原业务容器传入。 */
export default {
  name: "AgentServiceSendButton",
  props: {
    value: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    hasContent() { return this.value.trim().length > 0; },
  },
  methods: {
    /** 与Enter发送共用父级流程，不创建模型请求或改变草稿。 */
    send() {
      if (!this.disabled && this.hasContent) this.$emit("send");
    },
  },
};
</script>

<style lang="less" scoped>
.agent-service-send-button {
  display: inline-flex;
  flex: 0 0 44px;
  align-items: center;
  justify-content: center;
  width: 44px;
  min-width: 44px;
  height: 44px;
  box-sizing: border-box;
  padding: 0;
  border: 1px solid var(--m-border-default, #dde3ee);
  border-radius: 50%;
  background: var(--m-surface-muted, #f8fafc);
  color: var(--m-text-placeholder, #98a2b3);
  cursor: pointer;
  transition: background-color 160ms ease, color 160ms ease, border-color 160ms ease;

  svg { width: 22px; height: 22px; }
  &.has-content:not(:disabled) {
    border-color: var(--m-brand-200, #c7dcfd);
    background: var(--m-brand-100, #e6f0fe);
    color: var(--m-brand-600, #246de0);
    &:hover { background: #d9eaff; }
  }
  &:disabled { cursor: not-allowed; }
  &:focus-visible { outline: 2px solid #4286f5; outline-offset: 2px; }
  @media (prefers-reduced-motion: reduce) { transition: none; }
}
</style>
